const AccountSetting = () => {
  return <>Account Setting Page</>;
};

export default AccountSetting;
